import React, { useContext, useState } from "react";
import "./Overlay.css";
import { AppContext } from "../../context/AppContext"; // Ajuste o caminho se necessário
import Login from "../Login";
import Register from "../Register";

function Overlay({ isOpen, onClose }) {
    const { setIsOpenLogin } = useContext(AppContext);
    
    // Estado para alternar entre Login (true) e Register (false)
    const [isLoginView, setIsLoginView] = useState(true);

    if (!isOpen) return null;

    // Função passada para os filhos alternarem a visualização
    const toggleMode = () => {
        setIsLoginView(!isLoginView);
    };

    const handleClose = () => {
        setIsOpenLogin(false);
        if (onClose) onClose();
    };

    return (
        <div className="overlay">
            <div className="overlay-background" onClick={handleClose}></div>
            
            <div className="overlay-card">
                {/* Botão de Fechar (X) no canto superior direito */}
                <button className="overlay-close-btn" onClick={handleClose}>
                    &times;
                </button>

                {/* Renderização Condicional */}
                <div className="overlay-content">
                    {isLoginView ? (
                        <Login switchMode={toggleMode} />
                    ) : (
                        <Register switchMode={toggleMode} />
                    )}
                </div>
            </div>
        </div>
    );
}

export default Overlay;